import { FC, useCallback, useRef, HTMLAttributes } from 'react'
import { InteractionHandler } from 'components/features/pfm/InteractionHandler/InteractionHandler'
import { Omit } from 'interfaces'

type LineChartInteractionHandlerProps =
  & Omit<HTMLAttributes<HTMLElement>, 'onChange'>
  & {
    count: number
    width: number
    onChange: (index: number) => void
  }

export const LineChartInteractionHandler: FC<LineChartInteractionHandlerProps> = (props) => {
  const { children, count, width, onChange, ...restProps } = props

  const indexRef = useRef(-1)

  const handleInteraction = useCallback<(left: number) => void>((left) => {
    const sectionWidth = width / (count - 1)
    const index = Math.round(left / sectionWidth)

    if (indexRef.current !== index) {
      onChange(index)
      indexRef.current = index
    }
  }, [width, onChange, count])

  return (
    <InteractionHandler onInteraction={ handleInteraction } { ...restProps }>
      { children }
    </InteractionHandler>
  )
}
